import { render, staticRenderFns } from "./GroupGeo.vue?vue&type=template&id=375b4dc2&scoped=true"
import script from "./GroupGeo.vue?vue&type=script&lang=js"
export * from "./GroupGeo.vue?vue&type=script&lang=js"
import style0 from "./GroupGeo.vue?vue&type=style&index=0&id=375b4dc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375b4dc2",
  null
  
)

export default component.exports